module.exports = __webpack_public_path__ + "img/success-green.fef6ea26.svg";